import React, { useState, useCallback } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { usePagination } from "../hooks/usePagination";
import i18next from "i18next";
import "./style.css";

function debounce(func, timeout = 500) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export default function SearchSelectBox(props) {
  const { t } = useTranslation();
  const [searchTxt, setSearchTxt] = useState("");

  const { response, setMetaKey, meta } = usePagination(props.api, props.apiMeta);

  const setSearch = useCallback(
    debounce((input) => {
      setMetaKey("txt", input);
    }, 500),
    [setMetaKey]
  );

  const arr = response?.data?.[props.type] || response[props.type] || response || [];

  function getValue() {
    if (props.isMulti) {
      return props.value
        ? props.value.map((v) => ({
            ...v,
            label: v.label?.[i18next.language] || v.label,
            value: v.value,
          }))
        : [];
    } else {
      return props.value
        ? {
            ...props.value,
            label: props.value.label?.[i18next.language] || props.value.label,
            value: props.value.value,
          }
        : null;
    }
  }

  // Handle input change (typing)
  function handleInputChange(input) {
    setSearchTxt(input);
    setSearch(input);
  }

  return (
    <Select
      isDisabled={props.disabled}
      placeholder={t("forms.Select") + " ..."}
      value={getValue()}  
      onChange={props.setValue}
      isClearable
      onFocus={props.handleFocus}
      onBlur={props.handleBlur}
      isMulti={props.isMulti}
      inputValue={searchTxt}
      onInputChange={handleInputChange}
      options={arr
        .filter((c) => (c.id || c._id) !== props.exclude)
        .map((c) => ({
          ...c,
          label: c[props.label],
          value: c.id || c._id,
        }))}
      className={props.error ? "invalid api-select" : "api-select"}
    />
  );
}
